var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'row q-gutter-x-xs text-paragraph text-grey-8',
    { 'q-px-md': _vm.spacingX, 'q-py-md': _vm.spacingY }
  ]},[_c('span',[_vm._v("Based on")]),_c('span',{staticClass:"text-primary text-weight-bold"},[_vm._v(" "+_vm._s(_vm.leaseTerm)+" months ")]),_c('span',[_vm._v("at")]),_c('span',{staticClass:"text-primary text-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("thousands_integer")(_vm.kmsPerYear))+" km ")]),_c('span',[_vm._v("per annum")])])
}
var staticRenderFns = []

export { render, staticRenderFns }